import { all } from "redux-saga/effects";

import { keHoachKySaga } from "./keHoachKySaga";
import { keHoachNamSaga } from "./keHoachNamSaga";
import { keHoachTuanSaga } from "./keHoachTuanSaga";
import { keHoachKyHieuSaga } from "./keHoachKyHieuSaga";
import { keHoachLopSaga } from "./keHoachLopSaga";
import { keHoachMonSaga } from "./keHoachMonSaga";
import { giaiDoanSaga } from "./giaiDoanSaga";
import { keHoachMonFullPageSaga } from "./keHoachMonFullPageSaga";
import { ghepCapSaga } from "./ghepCapSaga";
import { keHoachMonHocNamHocHocKySaga } from "./keHoachMonHocNamHocHocKySaga";
import { keHoachMonNvSaga } from "./keHoachMonNvSaga";
import { keHoachNhomLopSaga } from "./keHoachNhomLopSaga";
import { keHoachMonToanKhoaSaga } from "./keHoachMonToanKhoaSaga";
import { xepTkbChuanBiSaga } from "./xepTkbChuanBiSaga";

export default function* keHoachSagaWrapper() {
  yield all([
    keHoachKySaga(),
    keHoachNamSaga(),
    keHoachTuanSaga(),
    keHoachKyHieuSaga(),
    keHoachLopSaga(),
    keHoachMonSaga(),
    giaiDoanSaga(),
    keHoachMonFullPageSaga(),
    ghepCapSaga(),
    keHoachMonHocNamHocHocKySaga(),
    keHoachMonNvSaga(),
    keHoachNhomLopSaga(),
    keHoachMonToanKhoaSaga(),
    xepTkbChuanBiSaga()
  ]);
}
